import React, { useState, useEffect } from 'react';
import '../assets/styles/home.css';
import image1 from '../assets/images/icons/1-escanear-codigo-QR.png';
import image2 from '../assets/images/icons/2-validar-informacion.png';
import image3 from '../assets/images/icons/3-generar-reporte.png';
import {useNavigate} from "react-router-dom";

export interface Profile {
    name: string;
    last_name: string;
    age: number;
    email: string;
}

const Home = () => {
    const [profile, setProfile] =  useState<Profile | null>(null);
    const navigate = useNavigate()

    const handleClick01 = () => {
        navigate('/qr_reader_view');
    };

    const handleClick02 = () => {
        navigate('/search_seller_by_document');
    };

    const handleClick03 = () => {
        navigate('/generate_report');
    };

    return (
        <div className="home-profile">
            <div className="images-container">
                <div className="image-box" onClick={handleClick01}>
                    <img src={image1} alt="QR Image" className="image"/>
                    <p className="title">Escanear código QR</p>
                    <p className="sub-title">Utiliza la cámara de tu dispositivo para escanear el código QR</p>
                </div>
                <div className="image-box" onClick={handleClick02}>
                    <img src={image2} alt="Search Image" className="image"/>
                    <p className="title">Buscar ventero por número de documento</p>
                </div>
                <div className="image-box" onClick={handleClick03}>
                    <img src={image3} alt="Report Image" className="image"/>
                    <p className="title">Generar reporte</p>
                </div>
            </div>
        </div>
    );
};

export default Home;
